import React from 'react';

export const EmptyState = ({ 
  title = 'No data found',
  description = 'Get started by creating a new item',
  icon: Icon = null,
  action = null,
  actionLabel = 'Create New'
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6" data-testid="empty-state">
      <div className="mb-4">
        {Icon ? <Icon /> : <span className="text-5xl">📦</span>}
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 text-center max-w-sm mb-6">{description}</p>
      {action && (
        <button
          onClick={action}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
